const didcsvcolumndata = [
  {
    id: "id",
    title: "ID",
  },
  {
    id: "country",
    title: "Country",
    default: true,
  },
  {
    id: "status",
    title: "Status",
    default: true,
  },
  {
    id: "did",
    title: "Number",
    default: true,
  },
  {
    id: "primary",
    title: "Primary",
    default: true,
  },
  {
    id: "description",
    title: "Description",
  },
];

export default didcsvcolumndata;
